import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface PaperRefsResponse<T = Record<string, unknown>> {
  refs: T[];
  total: number;
}

export function usePaperRefs<T = Record<string, unknown>>(
  conceptId: string | undefined,
  options: { fields: readonly string[]; role?: string },
) {
  const fieldsKey = [...options.fields].sort().join(",");
  return useQuery<PaperRefsResponse<T>>({
    queryKey: ["paper-refs", conceptId, fieldsKey, options.role],
    queryFn: () => {
      const params = new URLSearchParams({ fields: fieldsKey });
      if (options.role) params.set("role", options.role);
      return apiClient
        .get(`api/concepts/${conceptId}/papers/refs?${params.toString()}`)
        .json();
    },
    enabled: !!conceptId,
  });
}
